import patterns from '../../../../constants/patterns';

export default ({
  palette: { secondary },
  fonts,
  spacing,
  breakpoints: { down },
}) => ({
  faqContainer: {
    backgroundColor: secondary.main,
    position: 'relative',
    overflow: 'hidden',
  },
  title: {
    margin: ({ largeTopMargin }) =>
      largeTopMargin
        ? spacing(28, 0, 13, 0)
        : spacing(19, 0, 13, 0),
    [down('sm')]: {
      fontSize: fonts.size.l,
    },
    [down('xs')]: {
      margin: ({ largeTopMargin }) =>
        largeTopMargin
          ? spacing(20, 0, 13, 0)
          : spacing(13, 0, 13, 0),
    },
  },
  accordionContainer: {
    maxWidth: 1020,
    position: 'relative',
    zIndex: 2,
    margin: spacing(0, 'auto', 18, 'auto'),
    [down('md')]: {
      maxWidth: '100%',
    },
  },
  basePattern: {
    position: 'absolute',
    content: '""',
    height: 569,
    width: 725,
    background: `url(${patterns['alternatedSquares']})`,
    opacity: 0.15,
    zIndex: 1,
    '&::after': {
      position: 'absolute',
      content: '""',
      height: '100%',
      width: '100%',
      background: `radial-gradient(40.14% 47.44% at 22.34% 50.09%, rgba(255, 255, 255, 0.04) 0%, ${secondary.main} 100%)`,
    },
  },
  topRightPattern: {
    top: 100,
    right: -210,
    '&::after': {
      transform: 'rotate(-180deg)',
    },
    [down('md')]: {
      right: -270,
    },
  },
  bottomLeftPattern: {
    bottom: 100,
    left: -200,
    '&::after': {
      transform: 'matrix(1, 0, 0, -1, 0, 0)',
    },
    [down('md')]: {
      bottom: 0,
      left: -270,
    },
    [down('sm')]: {
      bottom: -200,
      left: -210,
    },
  },
});
